import React from 'react';
import { BackArrow } from '../../../Icons/BackArrow/BackArrow';
import './SettingsPageHeader.css';

export interface SettingsPageHeaderProps {
	title: string;
	canNavigateBack?: boolean;
	onNavigatingBack?: () => void;
	/** Optional content rendered on the right side of the header (e.g. search) */
	headerAction?: React.ReactNode;
}

export const SettingsPageHeader: React.FC<SettingsPageHeaderProps> = ({
	title,
	canNavigateBack = false,
	onNavigatingBack,
	headerAction,
}) => {
	return (
		<div className="settings-page-header-container">
			{canNavigateBack && onNavigatingBack && (
				<button className="settings-back-button" onClick={onNavigatingBack}>
					<BackArrow width={16} height={15} stroke="currentColor" />
				</button>
			)}
			<h1 className="settings-page-header">{title}</h1>
			{headerAction && <div className="settings-page-header-action">{headerAction}</div>}
		</div>
	);
};
